import { render, staticRenderFns } from "./saud.vue?vue&type=template&id=f01b2406&scoped=true&"
import script from "./saud.vue?vue&type=script&lang=js&"
export * from "./saud.vue?vue&type=script&lang=js&"
import style0 from "./saud.vue?vue&type=style&index=0&id=f01b2406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01b2406",
  null
  
)

export default component.exports